enum Property {
	TIMER_SETTINGS = 'Device.Timer.Settings',
	NATIVE_TIMER_SETTINGS = 'Device.Timer.NativeSettings',
	/**
	 * @deprecated Use front- or management-specific alternatives.
	 * @see ``POWER_ACTIONS_SCHEDULE_SETTINGS_FRONT``
	 * @see ``POWER_ACTIONS_SCHEDULE_SETTINGS_MANAGEMENT``
	 */
	POWER_ACTIONS_SCHEDULE_SETTINGS = 'Device.Power.Schedule',
	APPLET_TIMINGS_UPDATE_DEFINITION = 'AppletTiming.updateDefinition',
	BRIGHTNESS_SETTINGS = 'Device.Brightness.Settings',
	LAST_DEVICE_AUTH_HASH = 'Device.lastDeviceAuthHash',
	PIN = 'Input.enableControlPin',
	OFFLINE_ACTIONS_LISTS_PROPS = 'Offline.ActionsListsProps',
	DEBUG_WEINRE_ENABLED = 'Device.Debug.WeinreEnabled',
	DEBUG_WEINRE_SERVER_URL = 'Device.Debug.WeinreServerURL',
	CURRENT_TIMEZONE_OFFSET = 'DateTime.currentTimezoneOffset', // back compatible with cache storage
	INITIAL_SUBSCRIPTION_TYPE = 'Device.InitialSubscriptionType',
	LAST_SUCCESSFUL_PING_AT = 'License.LastSuccessfulPingAt',
	DEVICE_POLICY = 'Device.Policy',
	DEVICE_POLICY_FAILS_COUNT_VOLUME = 'Device.Policy.FailsCount.volume',
	DEVICE_POLICY_FAILS_COUNT_BRIGHTNESS = 'Device.Policy.FailsCount.brightness',
	DEVICE_POLICY_FAILS_COUNT_TIMERS = 'Device.Policy.FailsCount.timers',
	DEVICE_POLICY_FAILS_COUNT_PROPRIETARY_TIMERS = 'Device.Policy.FailsCount.proprietaryTimers',
	DEVICE_POLICY_FAILS_COUNT_ORIENTATION = 'Device.Policy.FailsCount.orientation',
	DEVICE_POLICY_FAILS_COUNT_RESOLUTION = 'Device.Policy.FailsCount.resolution',
	DEVICE_POLICY_FAILS_COUNT_REMOTE_CONTROL = 'Device.Policy.FailsCount.remoteControl',
	DEVICE_POLICY_FAILS_COUNT_APPLICATION_VERSION = 'Device.Policy.FailsCount.applicationVersion',
	DEVICE_POLICY_FAILS_COUNT_FIRMWARE_VERSION = 'Device.Policy.FailsCount.firmwareVersion',
	DEVICE_POLICY_FAILS_COUNT_DEBUG = 'Device.Policy.FailsCount.debug',
	DEVICE_POLICY_FAILS_COUNT_DATETIME = 'Device.Policy.FailsCount.datetime',
	DEVICE_POLICY_FAILS_COUNT_POWER_ACTIONS_SCHEDULE = 'Device.Policy.FailsCount.powerActionsSchedule',
	DEVICE_POLICY_FAILS_COUNT_TEMPERATURE = 'Device.Policy.FailsCount.temperature',
	DEVICE_POLICY_FAILS_COUNT_EXTENDED_MANAGEMENT = 'Device.Policy.FailsCount.extendedManagement',
	DEVICE_POLICY_FAILS_COUNT_PEER_RECOVERY = 'Device.Policy.FailsCount.peerRecovery',
	DEVICE_POLICY_FAILS_COUNT_AUTO_RECOVERY = 'Device.Policy.FailsCount.autoRecovery',
	DEVICE_POLICY_FAILS_COUNT_PLUGIN = 'Device.Policy.FailsCount.plugin',
	DEVICE_POLICY_FAILS_COUNT_RUNNER = 'Device.Policy.FailsCount.runner',
	SUPRA_SCREEN_CONFIG = 'Supra.Screen.Config',

	LATEST_REPORTED_SETTINGS_VOLUME = 'Device.Settings.Report.Cache.volume',
	LATEST_REPORTED_SETTINGS_BRIGHTNESS = 'Device.Settings.Report.Cache.brightness',
	LATEST_REPORTED_SETTINGS_TIMERS = 'Device.Settings.Report.Cache.timers',
	LATEST_REPORTED_SETTINGS_PROPRIETARY_TIMERS = 'Device.Settings.Report.Cache.proprietaryTimers',
	LATEST_REPORTED_SETTINGS_ORIENTATION = 'Device.Settings.Report.Cache.orientation',
	LATEST_REPORTED_SETTINGS_RESOLUTION = 'Device.Settings.Report.Cache.resolution',
	LATEST_REPORTED_SETTINGS_REMOTE_CONTROL = 'Device.Settings.Report.Cache.remoteControl',
	LATEST_REPORTED_SETTINGS_APPLICATION_VERSION = 'Device.Settings.Report.Cache.applicationVersion',
	LATEST_REPORTED_SETTINGS_FIRMWARE_VERSION = 'Device.Settings.Report.Cache.firmwareVersion',
	LATEST_REPORTED_SETTINGS_DEBUG = 'Device.Settings.Report.Cache.debug',
	LATEST_REPORTED_SETTINGS_DATETIME = 'Device.Settings.Report.Cache.datetime',
	LATEST_REPORTED_SETTINGS_POWER_ACTIONS_SCHEDULE = 'Device.Settings.Report.Cache.powerActionsSchedule',
	LATEST_REPORTED_SETTINGS_TEMPERATURE = 'Device.Settings.Report.Cache.temperature',
	LATEST_REPORTED_SETTINGS_BUNDLED_APPLET = 'Device.Settings.Report.Cache.bundledApplet',
	POWER_ACTIONS_SCHEDULE_SETTINGS_FRONT = 'Front.Device.Power.Schedule',
	POWER_ACTIONS_SCHEDULE_SETTINGS_MANAGEMENT = 'Management.Device.Power.Schedule',
	DEVICE_LOCATION = 'Device.Location',
	DEVICE_ORGANIZATION_TAGS = 'Device.OrganizationTags',
	DEVICE_PLUGINS = 'Device.Plugins',
	DEVICE_RUNNERS = 'Device.Runners',
	LATEST_REPORTED_SETTINGS_AUTO_RECOVERY = 'Device.Settings.Report.Cache.autoRecovery',
	LATEST_REPORTED_SETTINGS_PEER_RECOVERY = 'Device.Settings.Report.Cache.peerRecovery',
	LATEST_REPORTED_SETTINGS_MANAGEMENT_CAPABILITIES = 'Device.Settings.Report.Cache.managementCapabilities',
	LATEST_REPORTED_SETTINGS_FRONT_CAPABILITIES = 'Device.Settings.Report.Cache.frontCapabilities',
	LATEST_REPORTED_SETTINGS_WIFI_STRENGTH = 'Device.Settings.Report.Cache.wifiStrength',
	LATEST_REPORTED_SETTINGS_PROXY = 'Device.Settings.Report.Cache.proxy',
	LATEST_REPORTED_SETTINGS_NETWORK_INTERFACES = 'Device.Settings.Report.Cache.networkInterfaces',
	LATEST_REPORTED_SETTINGS_DISPLAY_POWER_ON = 'Device.Settings.Report.Cache.displayPowerOn',
	LATEST_REPORTED_SETTINGS_APP_MODULES = 'Device.Settings.Report.Cache.appModules',
	LATEST_REPORTED_SETTINGS_FEATURE_FLAGS = 'Device.Settings.Report.Cache.featureFlags',
	LATEST_REPORTED_SETTINGS_CRYPTOGRAPHIC_KEY = 'Device.Settings.Report.Cache.cryptographicPublicKey',
	LATEST_REPORTED_SETTINGS_EXTENDED_MANAGEMENT = 'Device.Settings.Report.Cache.extendedManagement',
	LATEST_REPORTED_SETTINGS_APPLET = 'Device.Settings.Report.Cache.applet',
	LATEST_REPORTED_SETTINGS_PLUGIN = 'Device.Settings.Report.Cache.plugin',
	LATEST_REPORTED_SETTINGS_RUNNER = 'Device.Settings.Report.Cache.runner',
	LATEST_REPORTED_SETTINGS_RUNNER_CUSTOM = 'Device.Settings.Report.Cache.runnerCustom',
	LATEST_REPORTED_SETTINGS_CPU_USAGE = 'Device.Settings.Report.Cache.cpuUsage',
	LATEST_REPORTED_SETTINGS_MEMORY_USAGE = 'Device.Settings.Report.Cache.memoryUsage',
	LATEST_REPORTED_SETTINGS_INSTALLED_PACKAGES = 'Device.Settings.Report.Cache.installedPackages',
	LATEST_REPORTED_SETTINGS_SUPRA = 'Device.Settings.Report.Cache.supra',
	TELEMETRY_STACK_STORAGE = 'Device.Telemetry.StackStorage',
	TELEMETRY_INVALIDATION = 'Device.Telemetry.cacheInvalidationInterval',
	TELEMETRY_INVALIDATED_AT = 'Device.Telemetry.telemetryInvalidatedAt',
	TELEMETRY_TYPE_INVALIDATION = 'Device.Telemetry.typeInvalidation',
	TELEMETRY_NEXT_INVALIDATION_AT = 'Device.Telemetry.nextInvalidationAt',
}
export default Property;
